import { render, staticRenderFns } from "./DSCommunicationCard.vue?vue&type=template&id=4a907eb4&"
import script from "./DSCommunicationCard.vue?vue&type=script&lang=js&"
export * from "./DSCommunicationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports